const IngredientsList = ({ ingredients }) => (
	<div className="ingredients-list">
		<h3>Ingredients:</h3>
		<ul>
			{ingredients.map((i, ii) => (
				<li key={ii}>
					{!i ? '---' : i.name}
				</li>
			))}
		</ul>
	</div>
);

export default IngredientsList;
